// utils/permisos.js — comprobación de permisos en el frontend
export function puede(usuario, modulo, accion) {
  if (!usuario) return false;
  if (usuario.rol === 'superadmin' || usuario.rol === 'admin') return true;
  const p = (usuario.permisos || []).find((x) => x.modulo === modulo);
  return !!(p && p.acciones.includes(accion));
}

export function puedeElegirIA(usuario) {
  if (!usuario) return false;
  if (usuario.rol === 'superadmin') return true;
  const p = (usuario.permisos || []).find((x) => x.modulo === 'ia');
  return !!(p && Array.isArray(p.acciones) && p.acciones.includes('eleccion_ia'));
}
